import React, { Component } from "react";
import { Navigate, Link } from "react-router-dom";
import { Modal, Form, Button }  from 'react-bootstrap';

import moment from 'moment';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import VirtualKeyboard from "../../components/VirtualKeyboard";

import { FaIdCard, FaFlag, FaCaretLeft, FaCaretRight } from 'react-icons/fa6';

import { withRouter } from '../../with-router';
import AuthService from "../../services/auth";
import GameService from "../../services/game";
import FirebaseService from "../../services/firebase";

import Numpad from "../../components/Numpad";
import './Home.css';

// Remote Game Launch — see docs/remote-game-launch-plan.md
// Standalone Web Promotion — see docs/standalone-web-promotion-plan.md
import { readRemoteSession, storeRemoteSession, isWebSession, exitPath} from "../../context/RemoteLaunchContext";
import { exitGame, playerEcho } from "../../utils/exitGame";
import WebService from "../../services/web";

const CHAR_BeginningOfSubstring = ';';
const CHAR_EndingOfSubstring = '?';

// Standalone web promotion idle timeout. Matches the server's LaunchSession
// lifetime (SESSION_TTL_SECONDS in web_views.py), so the page gives up at
// roughly the moment the session behind it stops being usable anyway.
const WEB_IDLE_MS = 30 * 60 * 1000;

// Magnetic-stripe start sentinels we accept: ';' (track 2) and '%' (track 1).
// A reader may emit either depending on which track the customer's card encodes.
const CARD_START_SENTINELS = [';', '%'];

// Reduce a raw swipe to the bare customer/card number. Readers vary: some emit a
// start sentinel (';' track 2, '%' track 1), some don't; an empty track reads as
// "%E?"; data may be followed by a '=' separator or trailing device-status text.
// Across all of these the account number is the first run of digits, so extract
// that — it skips empty/error tracks, sentinels, and junk.
//
// Values without any swipe marker (manual entry, the "logout" command, an already
// clean number) pass through untouched so non-swipe callers are unaffected.
function stripCardSentinels(raw){
    if (!raw) return raw;
    var s = ("" + raw).trim();
    var hasSwipeMarkers = CARD_START_SENTINELS.indexOf(s.charAt(0)) !== -1
                          || s.indexOf(CHAR_EndingOfSubstring) !== -1;
    if (!hasSwipeMarkers) return s;
    var digits = s.match(/\d{3,}/);   // account number = first run of >=3 digits
    return digits ? digits[0] : "";
}

const arrowStyles = {
    position: 'absolute',
    zIndex: 2,
    top: "0",
    height: "100%",
    borderRadius: "0",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    border: "0px"
};

class Home extends Component {
    constructor(props) {
        super(props);
        this.cardReadTimer = null; // timer for 2s inactivity cutoff

        // Remote Game Launch — non-null when the iframe was started by /launch-entry.
        this.remoteSession = null;
        this.pendingRemoteResult = null;

        this.processing = false;
        this.state = {
            vid: "",
            page_ready: false,
            read_card_ready: false,
            redirect: null,
            venue: null,
            promos: [],
            eariliest_date: null,
            card_input: "",
            modal: {show: false, text: ""},
            player_error_modal: {show: false, title: "", body: "", image: null, retry: null},
            pin_modal: false,
            register_modal: false,
            update_modal: false,
            dupe_email_modal: false,
            welcome_modal: false,
            pcr_welcome_modal: false,
            register_input: {email: "", firstname: "", lastname: "", valid: false},
            // Why Continue did not go through, shown beside the button that was
            // pressed. Empty when there is nothing to say.
            register_error: "",
            input_name: "firstname",
            player: null,
            click: false,
            // Standalone web promotion only. club_modal asks for the number,
            // web_confirm_modal confirms the profile that came back, and
            // club_locked is the number itself — shown read-only on the
            // confirmation screen and used to create the player.
            club_modal: false,
            club_input: "",
            club_locked: "",
            web_confirm_modal: false,
        };
        this.timeout_function = null;
        this.register_timeout_function = null;
        this.keyboard = React.createRef();

        const locale = window.navigator.language || 'en-us'
        this.date = new Date();
        this.dayNum = this.date.getDate();
        this.month = this.date.getMonth();
        this.dayName = this.date.toLocaleString(locale, { weekday: 'long' });
        this.monthName = this.date.toLocaleString(locale, { month: 'long' });
        this.year = this.date.getFullYear();
    }

    isRemote(){
        return !!(this.remoteSession && this.remoteSession.isRemote);
    }

    // A "trusted" launching page (e.g. a DART kiosk that just collected the
    // patron's name and email) owns player identity: the backend resolved or
    // created the player before the frame loaded, so we never ask again.
    isTrustedRegistration(){
        var opts = (this.remoteSession && this.remoteSession.displayOptions) || {};
        return this.isRemote() && opts.registrationMode === "trusted";
    }

    // Standalone web promotion (/go/<slug>): an ordinary browser page, not an
    // embedded frame. The player identifies themselves here rather than
    // arriving pre-identified, and a 160-day cookie remembers them afterwards.
    isWebMode(){
        return this.isRemote() && isWebSession(this.remoteSession);
    }

    remoteCtx(){
        var s = this.remoteSession || {};
        return {
            isRemote: this.isRemote(),
            parentOrigin: s.parentOrigin || null,
            registeredThisSession: !!s.registeredThisSession,
        };
    }

    markRegisteredThisSession(){
        if (!this.isRemote()) return;
        this.remoteSession = Object.assign({}, this.remoteSession, { registeredThisSession: true });
        storeRemoteSession(this.remoteSession);
    }

    componentDidMount() {
        // Initialize remote-launch session BEFORE anything else so we can branch on it.
        this.remoteSession = readRemoteSession();

        localStorage.removeItem("demo_user")
        this.props.showModal("Loading...")
        let local_bg = localStorage.getItem("home_bg");
        if(local_bg != null) this.backgroundImage(local_bg);

        GameService.getVenueAndGames().then((data) => {
            //console.log(data);
            let eariliest = null;
            data.promos.forEach((a, index) => {
                if(a.promoperiods.length){
                    a.promoperiods.forEach(b => {
                        if(eariliest == null) eariliest = moment(b.event_start_time);
                        else{
                            let isBefore = moment(b.event_start_time).isBefore(eariliest);
                            if(isBefore) eariliest = moment(b.event_start_time);
                        }
                    })
                }else{
                    data.promos.splice(index, 1);
                }
            })

            var new_promos = data.promos.filter(a => {
                return moment().isBetween(moment(a.promo.start_time), moment(a.promo.end_time)) && a.promo.status == 1
            });

            // Remote launch: remember how many promotions are live so exitGame()
            // can decide, at the end of a game, whether there is anything left to
            // come back for. Stored on the session because the game pages are a
            // full navigation away from here.
            if (this.isRemote()) {
                this.remoteSession = Object.assign({}, this.remoteSession, {
                    promoCount: new_promos.length,
                });
                storeRemoteSession(this.remoteSession);
            }

            this.setState({
                // `|| ""` is load-bearing: lobby_background_image_url is null for
                // any venue without one, and .includes() on null throws — which
                // aborts this whole handler, so hideModal() below never runs and
                // the player watches "Loading..." forever with no error on screen.
                vid: (data.venue.lobby_background_image_url || "").includes("mp4")
                    ? data.venue.lobby_background_image_url
                    : "",
                eariliest_date: eariliest,
                page_ready: true,
                venue: data.venue,
                promos: new_promos
            }, () => {
                if(this.state.venue.lobby_background_image_url) this.backgroundImage(this.state.venue.lobby_background_image_url);
                else this.backgroundImage("");

                // SUR-402 — arriving back from the entry manager's "Play Now" on
                // a non-Survivor promotion. The lobby owns those launch rules
                // (daily limit, error copy, remote-session bookkeeping) and a
                // second copy of that state machine would drift, so the entry
                // manager sends the player here with the promo id instead.
                if(this.consumeAutoPlay()) return;

                if (this.isRemote()) {
                    this.props.hideModal();
                    this.bootstrapRemoteLaunch();
                } else {
                    this.registerKeyInputEvent();
                    this.props.hideModal();
                    this.getCardNumberFromURL();
                }

                //if(this.state.promos.length == 1) this.renderCalendarPage();
            })
        }).catch(error => {
            console.log(error)
            // Unconditionally, before anything branches. hideModal() used to live
            // only on the success path, so any throw in the handler above -- or
            // any non-401 response -- left the "Loading..." overlay up with
            // nothing on screen to say what happened. A visible failure beats a
            // silent hang.
            this.props.hideModal();
            if(error.response && error.response.status == 401){
                if (this.isRemote()) {
                    exitGame({
                        remoteCtx: this.remoteCtx(),
                        setRedirect: (r) => this.setState({redirect: r}),
                        result: "error",
                    });
                    return;
                }
                AuthService.refreshAuth().then((data) => {
                    window.location.reload(false);
                }).catch(error => {
                    AuthService.logout();
                    // WEB-410 -- the route a returning web player actually
                    // takes. Their token has expired, the refresh fails, and
                    // this used to hand them the kiosk login.
                    this.setState({ redirect: { path: exitPath(), state: null } }, () => {
                        this.props.hideModal();
                    });
                });
            }
        }).finally(() => {
            // The 20-min idle reload is for unattended kiosks; the parent owns
            // iframe lifetime for remote launches, so skip it there.
            if (!this.isRemote()) this.startTwentyMinTimeout();
        });
    }

    bootstrapRemoteLaunch(){
        if (!this.remoteSession) return;

        // Standalone web takes a different path from here: nobody has declared
        // an identifier, because collecting one is this flow's whole job. Kept
        // as an early return so the token flow below is untouched.
        if (this.isWebMode()) {
            this.bootstrapWebLaunch();
            return;
        }

        var idType = this.remoteSession.identifierType || "card";
        var card_num = this.remoteSession.cardNumber;
        var club_num = this.remoteSession.clubNumber;
        var prefill = this.remoteSession.prefill || {};

        // Must have the identifier the caller declared.
        var missingIdentifier = (idType === "club") ? !club_num : !card_num;
        if (missingIdentifier) {
            exitGame({
                remoteCtx: this.remoteCtx(),
                setRedirect: (r) => this.setState({redirect: r}),
                result: "error",
            });
            return;
        }

        if (prefill.promo_error && this.state.promos.length === 0) {
            this.pendingRemoteResult = "no_promotion";
            this.tooglePlayerErrorModal(true, "Promotion not available",
                "That promotion is not available. Please contact the launching site for help.");
            return;
        }

        if (this.state.promos.length === 0) {
            this.pendingRemoteResult = "no_promotion";
            this.tooglePlayerErrorModal(true, "No current promotions",
                "There are no active promotions at this time.");
            return;
        }

        // Trusted launching page: the player is already settled server-side and
        // hydrated into the session. Take it as-is — no card lookup (the launcher's
        // card string may not round-trip through the swipe normalizer) and no form.
        if (this.isTrustedRegistration() && this.remoteSession.player) {
            var trusted_player = this.remoteSession.player;
            if (trusted_player.card_number == null) trusted_player.card_number = card_num || "";
            this.proceedWithResolvedPlayer(trusted_player);
            return;
        }

        if (idType === "club") {
            // The player was resolved server-side by club number and hydrated into
            // the session. Present → dispatch; absent → register a new club member
            // (no card record is created — see RegisterClubMemberAPI).
            var player = this.remoteSession.player;
            if (player) {
                if (player.card_number == null) player.card_number = "";
                this.proceedWithResolvedPlayer(player);
            } else {
                this.showRegistrationModal("");
            }
            return;
        }

        // Card flow — same path as a real swipe.
        this.getPlayerInfo(card_num);
    }

    // ---------------------------------------------------------------------
    // Standalone Web Promotion — see docs/standalone-web-promotion-plan.md
    // ---------------------------------------------------------------------

    bootstrapWebLaunch(){
        // "There is nothing to play" is worth saying before anything else.
        // Asking somebody to identify themselves and only then telling them
        // there is no game is the wrong order.
        if (this.state.promos.length === 0) {
            this.pendingRemoteResult = "no_promotion";
            this.tooglePlayerErrorModal(true, "No current promotions",
                "There are no active promotions at this time. Please check back soon.");
            return;
        }

        // Armed for both paths below, not just the dialog — an abandoned tab
        // sitting on the lobby should time out too.
        this.registerWebIdlelisteners();

        // The cookie was read at /go/ and the player hydrated into the session,
        // so a returning player never sees the club dialog — not even briefly.
        var known = this.remoteSession.player;
        if (known) {
            if (known.card_number == null) known.card_number = "";
            this.proceedWithResolvedPlayer(known);
            return;
        }

        this.setState({ club_modal: true });
    }

    submitClubNumber(){
        var club = (this.state.club_input || "").trim();
        if (!club) return;

        this.setState({ club_modal: false, club_locked: club });
        this.props.showModal("Looking you up...");

        GameService.lookupClubMember(club).then((player) => {
            this.props.hideModal();
            // The server answers three ways now, and it decides -- only it can
            // read the venue's member roster, and a rule the client enforces
            // is one anybody can skip by posting straight at the endpoint.
            //
            //   a player  -> known, prefill the confirmation
            //   204/empty -> nobody yet, and they may register
            //   404       -> turned away (handled below)
            this.openWebConfirm(club, player || null);
        }).catch((error) => {
            this.props.hideModal();
            var notFound = !!(error.response && error.response.status === 404);

            if (notFound) {
                // This venue does not register unknown numbers, and there is
                // nothing the player can do from here — hence a dead end
                // rather than a retry.
                this.pendingRemoteResult = "not_recognised";
                // The number is quoted back because a player cannot check a
                // number they cannot see -- a mistyped digit and a number that
                // genuinely is not a member look identical otherwise, and only
                // one of them is worth walking to the desk over.
                this.tooglePlayerErrorModal(true, "Not recognised",
                    "We don't recognise Players Club number " + club + ". "
                    + "Check the number and try again, or visit the Players "
                    + "Club desk to get set up.",
                    null,
                    () => this.setState({ club_modal: true, club_locked: "" }));
                return;
            }

            console.log(error);
            this.setState({ club_modal: true });
        });
    }

    /**
     * The confirmation screen, shown on every first visit — including for a
     * player we found with a complete profile. That is deliberate: a stale
     * email is the most common real-world data problem, and this is the only
     * place the player can fix it. It costs one screen per device per 160 days.
     */
    openWebConfirm(club, player){
        this.setState({
            club_locked: club,
            player: player || null,
            register_input: {
                email: (player && player.email) || "",
                firstname: (player && player.first_name) || "",
                lastname: (player && player.last_name) || "",
                valid: false,
            },
        }, () => {
            this.checkInputValue();
            this.setState({ web_confirm_modal: true });
        });
    }

    submitWebRegistration(){
        var club = this.state.club_locked;
        var email = this.state.register_input.email;
        var firstname = this.state.register_input.firstname;
        var lastname = this.state.register_input.lastname;
        var existing = this.state.player;

        this.setState({ web_confirm_modal: false });
        this.props.showModal(existing ? "Saving your details..." : "Registering...");

        FirebaseService.logEvent(
            existing ? "web_update_player" : "web_register_club_member",
            {"venue_id": this.state.venue.id, "club_num": club, "email": email}
        );

        var save;
        if (existing) {
            save = GameService.postUpdatePlayer(existing.id, firstname, lastname, email)
                .then(() => {
                    var updated = JSON.parse(JSON.stringify(existing));
                    updated.first_name = firstname;
                    updated.last_name = lastname;
                    updated.email = email;
                    return updated;
                });
        } else {
            save = GameService.postNewClubMember(club, email, firstname, lastname);
        }

        save.then((player) => {
            if (player.card_number == null) player.card_number = "";
            this.markRegisteredThisSession();
            return this.rememberPlayer(player).then(() => player);
        }).then((player) => {
            this.props.hideModal();
            this.setState({ player: player }, () => {
                // SUR-401 -- a live Survivor promotion takes over the lobby.
                // Its entry manager lists every active promotion (SUR-402), so
                // there is nothing the lobby would still be needed for.
                if(this.toPrePickIfSurvivor()) return;
                if (this.state.promos.length == 1) {
                    this.playGame(this.state.promos[0]);
                } else {
                    this.setState({ welcome_modal: true });
                }
            });
        }).catch((error) => {
            console.log(error);
            this.props.hideModal();
            this.processing = false;
            // Put them back on the form rather than stranding them — the most
            // likely cause is an email the server rejected.
            this.setState({ web_confirm_modal: true });
        });
    }

    /**
     * Set the 160-day identity cookie.
     *
     * Never fatal. A player who cannot be remembered is simply asked for their
     * club number again next time, which is the ordinary first-visit path — so
     * failing here must not cost them the game they are about to play.
     */
    rememberPlayer(player){
        var sid = this.remoteSession && this.remoteSession.sessionId;
        if (!sid || !player || !player.id) return Promise.resolve();
        return WebService.remember(sid, player.id).catch((error) => {
            console.log("Could not remember this device:", error);
        });
    }

    /**
     * Idle timeout for the standalone web flow.
     *
     * Neither existing timer fits. The kiosk's 20-minute reload would reload
     * into a session the server has already expired, and the 60-second
     * registration timer is far too aggressive for somebody typing an email on
     * their own phone. 30 minutes matches the server's LaunchSession lifetime.
     *
     * Idle, not absolute: it resets on interaction, so an active player is
     * never interrupted mid-registration. It exists for the abandoned tab —
     * and so a shared device does not sit on somebody's half-filled form.
     *
     * Covers the lobby and the identification screens. Once the player is in a
     * game, that page owns the session and ends it at the receipt.
     */
    startWebIdleTimeout(){
        if (!this.isWebMode()) return;
        if (this.web_idle_timeout) clearTimeout(this.web_idle_timeout);
        this.web_idle_timeout = setTimeout(() => {
            this.pendingRemoteResult = "timed_out";
            exitGame({
                remoteCtx: this.remoteCtx(),
                setRedirect: (r) => this.setState({redirect: r}),
                result: "timed_out",
            });
        }, WEB_IDLE_MS);
    }

    registerWebIdlelisteners(){
        if (!this.isWebMode()) return;
        this.webIdleReset = () => this.startWebIdleTimeout();
        ["click", "keydown", "touchstart"].forEach((evt) => {
            document.addEventListener(evt, this.webIdleReset, { passive: true });
        });
        this.startWebIdleTimeout();
    }

    clearWebIdleListeners(){
        if (this.web_idle_timeout) clearTimeout(this.web_idle_timeout);
        if (!this.webIdleReset) return;
        ["click", "keydown", "touchstart"].forEach((evt) => {
            document.removeEventListener(evt, this.webIdleReset);
        });
        this.webIdleReset = null;
    }

    componentWillUnmount(){
        if(this.timeout_function) clearTimeout(this.timeout_function);
        if(this.register_timeout_function) clearTimeout(this.register_timeout_function);
        if(this.cardReadTimer) clearTimeout(this.cardReadTimer);
        this.clearWebIdleListeners();
    }

    getCardNumberFromURL(){
        var card_number = "";
        if(this.props.router.location.search){
            let search_params = this.props.router.location.search;
            let params = new URLSearchParams(search_params);
            if(params.has('card_number')) card_number = params.get("card_number");
        }
        if(card_number != "" && (CARD_START_SENTINELS.indexOf(card_number.charAt(0)) !== -1 || card_number.indexOf("?") !== -1)){
            this.getPlayerInfo(card_number);  // getPlayerInfo extracts the bare number
        }
    }

    startTwentyMinTimeout(){
        // Idle reload is for unattended kiosks. The parent owns iframe lifetime for
        // remote launches, so skip it there.
        if (this.isRemote()) return;
        if(this.timeout_function) clearTimeout(this.timeout_function);
        this.timeout_function = setTimeout(() => {
            window.location.reload();
        }, 1.2e+6)
    }

    backgroundImage(bg){
        let html = document.getElementsByTagName("html");
        if(html.length > 0){
            if(bg) html[0].style.backgroundImage = "url('" + bg + "')";
            else html[0].style.backgroundImage = "";

            localStorage.setItem("home_bg", bg);
        }

        let home_bg = document.getElementsByClassName("home-background");
        if(home_bg.length > 0){
            if(bg) home_bg[0].style.backgroundImage = "url('" + bg + "')";
            else home_bg[0].style.backgroundImage = "";
        }
    }

// Register input event for card swipes (any string ending with Enter/newline).
    // Also defensively completes after 2s of inactivity if no newline is received.
    registerKeyInputEvent(){
        const restartInactivityTimer = () => {
            if (this.cardReadTimer) clearTimeout(this.cardReadTimer);
            // 2-second inactivity timeout
            this.cardReadTimer = setTimeout(() => {
                if (this.state.read_card_ready && this.state.card_input !== "") {
                    const card_num = this.state.card_input;
                    this.setState(
                        { read_card_ready: false, modal: { show: false, text: "" }, card_input: "" },
                        () => this.getPlayerInfo(card_num)
                    );
                }
            }, 2000);
        };

        document.addEventListener("keyup", (e) => {
            if (this.processing) return;

            // Complete on Enter/newline (typical for modern readers)
            if (e.key === "Enter") {
                if (this.state.read_card_ready) {
                    if (this.cardReadTimer) clearTimeout(this.cardReadTimer);
                    const card_num = this.state.card_input;
                    this.setState(
                        { read_card_ready: false, modal: { show: false, text: "" }, card_input: "" },
                        () => this.getPlayerInfo(card_num)
                    );
                }
                return;
            }

            // Accept any printable single-character key as part of the swipe
            if (e.key && e.key.length === 1) {
                // If we're idle, show the reading state on first character
                if (!this.state.read_card_ready) {
                    if (this.state.modal.show === false) {
                        this.setState({ read_card_ready: true, modal: { show: true, text: "Reading card..." }, pin_modal: false });
                    } else {
                        this.setState({ read_card_ready: true });
                    }
                }

                const new_card_num = this.state.card_input + e.key;
                this.setState({ card_input: new_card_num }, restartInactivityTimer);
                return;
            }

            // keep backward compatibility if an old reader still sends '?'
            if (e.key === CHAR_EndingOfSubstring && this.state.read_card_ready) {
                if (this.cardReadTimer) clearTimeout(this.cardReadTimer);
                const card_num = this.state.card_input;
                this.setState(
                    { read_card_ready: false, modal: { show: false, text: "" }, card_input: "" },
                    () => this.getPlayerInfo(card_num)
                );
            }
        });
    }
    
    getPlayerInfo(card_num){
        // Normalize raw swipe (any track, with/without sentinels) to the bare number.
        card_num = stripCardSentinels(card_num);
        if(!card_num) return;  // empty / error-track read — nothing to look up
        if(card_num.toLowerCase() == "logout"){
            this.setState({ redirect: { path:"/logout", state: null } });
            return;
        }

        this.processing = true;
        this.props.showModal("Getting player info...")

        let new_card_num = card_num
        if(card_num == "SYCUANTEST999"){
            new_card_num = "007017071400977383";
        } else if (card_num == "PECHANGATEST1"){
            new_card_num = "011026000093801341"
        } else if (card_num == "PECHANGATEST2"){
            new_card_num = "011026000092703533";
        }

        FirebaseService.logEvent("card_swipe", {"venue_id": this.state.venue.id, "card_num": new_card_num})
        GameService.getPlayer(new_card_num).then((data) => {
            //console.log(data)
            if(data.card_number == null) data.card_number = new_card_num
            this.proceedWithResolvedPlayer(data);

        }).catch(error => {
            console.log(error)
            if(error.response.status == 404){
                if(this.isPechangaCasinoSpecialCase()){
                    this.ifPechangaCasinoCardNumberValidCreateNewPlayer(new_card_num);
                }else{
                    this.showRegistrationModal(new_card_num);
                }

            }else{
                this.processing = false;
            }
        }).finally(() => {
            this.startTwentyMinTimeout();
            this.props.hideModal();
        });
    }


    // Shared post-lookup dispatch: a player has been resolved (by card or club).
    // If their profile is incomplete, show the registration/update modal pre-filled;
    // otherwise go straight to the game / welcome screen.
    proceedWithResolvedPlayer(data){
        this.setState({
            player: data
        }, () => {
            var incomplete =
                (data.first_name == "" || data.first_name == null) ||
                (data.last_name == "" || data.last_name == null) ||
                (data.email == "" || data.email == null);

            // Trusted launching page: its data is the record of truth and was
            // already written to the player. A missing name is not worth
            // interrupting a patron who typed it into the kiosk a moment ago.
            if(incomplete && this.isTrustedRegistration() && data.email) incomplete = false;

            if(incomplete && !this.isPechangaCasinoSpecialCase()){
                this.clearAllInput();

                var curr_email = (data.email == "" || data.email == null) ? "" : data.email
                var curr_first_name = (data.first_name == "" || data.first_name == null) ? "" : data.first_name
                var curr_last_name = (data.last_name == "" || data.last_name == null) ? "" : data.last_name

                if (this.isRemote()) {
                    var pf = (this.remoteSession && this.remoteSession.prefill) || {};
                    if (!curr_email) curr_email = pf.email || "";
                    if (!curr_first_name) curr_first_name = pf.first_name || "";
                    if (!curr_last_name) curr_last_name = pf.last_name || "";
                    if (pf.hide_registration && !curr_email) {
                        this.processing = false;
                        this.props.hideModal();
                        this.pendingRemoteResult = "email_required";
                        this.tooglePlayerErrorModal(true, "Email required",
                            "Email registration required to play. Please visit a kiosk to register.");
                        return;
                    }
                }

                this.setState({
                    register_input: {email: curr_email, firstname: curr_first_name, lastname: curr_last_name, valid: false}
                }, () => {
                    this.toggleUpdateModal(true);
                })
            }else{
                // SUR-401 -- a live Survivor promotion takes over the lobby.
                // Its entry manager lists every active promotion (SUR-402), so
                // there is nothing the lobby would still be needed for.
                if(this.toPrePickIfSurvivor()) return;
                if(this.state.promos.length == 1){
                    this.playGame(this.state.promos[0]);
                }else{
                    this.setState({
                        welcome_modal: true
                    })
                }
            }
        })
    }

    isPechangaCasinoSpecialCase(){
        if(this.state.venue.name.toLowerCase().includes("pechanga")){
            return true;
        }
        return false;
    }

    isPCRSpecialCase(){
        if(this.state.venue.name.toLowerCase().includes("pcr employees")){
            return true;
        }
        return false;
    }

    ifPechangaCasinoCardNumberValidCreateNewPlayer(card_num) {
        GameService.getPlayerCardNumberRegistered(card_num).then( response => {
            if(response != null){
                if(response.user_exists){
                    // Create the new player:
                    this.setState({
                        card_input: card_num,
                        register_modal: false,
                        register_input: {email: "", firstname: "", lastname: "", valid: false}
                    });
                    this.registerNewPlayer(this, card_num);
                }else{
                    this.tooglePlayerErrorModal(true, "Something went wrong!", "We couldn't complete your request.\nPlease see the players club.");                }
            }
        }).catch(error => {
            console.log(error);
            this.tooglePlayerErrorModal(true, "Something went wrong!", "We couldn't complete your request.\nPlease see the players club.");
        });
    }

    showRegistrationModal(card_num){
        FirebaseService.logEvent("register_card_prompt", {"venue_id": this.state.venue.id, "card_num": card_num})

        var initial = {email: "", firstname: "", lastname: "", valid: false};
        if (this.isRemote()) {
            var pf = (this.remoteSession && this.remoteSession.prefill) || {};
            if (pf.hide_registration && !pf.email) {
                this.processing = false;
                this.props.hideModal();
                this.pendingRemoteResult = "email_required";
                this.tooglePlayerErrorModal(true, "Email required",
                    "Email registration required to play. Please visit a kiosk to register.");
                return;
            }
            initial = {
                email: pf.email || "",
                firstname: pf.first_name || "",
                lastname: pf.last_name || "",
                valid: false,
            };
        }

        this.setState({
            card_input: card_num,
            register_input: initial
        }, () => {
            this.clearAllInput();
            this.toggleRegisterModal(true);
        })
    }

    submitPin(new_input){
        //console.log(new_input);
        //this.redirectToGame();

        // SUR-401 -- a live Survivor promotion takes over the lobby.
        // Its entry manager lists every active promotion (SUR-402), so
        // there is nothing the lobby would still be needed for.
        if(this.toPrePickIfSurvivor()) return;
        if(this.state.promos.length == 1){
            this.playGame(this.state.promos[0]);
        }else{
            this.setState({
                pin_modal: false,
                welcome_modal: true
            })
        }
    }

    checkExistingPlayer(e){
        e.preventDefault();

        let email = this.state.register_input.email;
        let firstname = this.state.register_input.firstname;
        let lastname = this.state.register_input.lastname;

        this.props.showModal("Registering new player...")
        this.toggleRegisterModal(false);

        GameService.postSearchPlayer(email, firstname, lastname).then((data) => {
            this.setState({
                player: data
            }, () => {
                this.toggleDupeEmailModal(true);
            })
        }).catch(error => {
            console.log(error);
            if(error.response.status == 404){
                this.registerNewPlayer();
            }else{
                this.processing = false;
            }
        }).finally(() => {
            this.startTwentyMinTimeout();
            this.props.hideModal();
        });
    }

    registerNewPlayer(e, card_number = ""){
        // if(e) e.preventDefault();

        let email = this.state.register_input.email;
        let firstname = this.state.register_input.firstname;
        let lastname = this.state.register_input.lastname;

        // Remote club-number launch: create a player carrying the club number and
        // no card. The ticket attaches to the player, so no PlayerCard is needed.
        if (this.isRemote() && this.remoteSession && this.remoteSession.identifierType === "club") {
            let club = this.remoteSession.clubNumber;
            this.props.showModal("Registering new player...");
            this.toggleDupeEmailModal(false);
            this.toggleRegisterModal(false);
            FirebaseService.logEvent("register_club_member", {"venue_id": this.state.venue.id, "club_num": club, "email": email});
            GameService.postNewClubMember(club, email, firstname, lastname).then((data) => {
                if (data.card_number == null) data.card_number = "";
                this.markRegisteredThisSession();
                this.setState({
                    card_input: "",
                    register_modal: false,
                    register_input: {email: "", firstname: "", lastname: "", valid: false},
                    player: data
                }, () => {
                    // SUR-401 -- a live Survivor promotion takes over the lobby.
                    // Its entry manager lists every active promotion (SUR-402), so
                    // there is nothing the lobby would still be needed for.
                    if(this.toPrePickIfSurvivor()) return;
                    if (this.state.promos.length == 1) {
                        this.playGame(this.state.promos[0]);
                    } else {
                        this.setState({ welcome_modal: true });
                    }
                });
            }).catch(error => {
                console.log(error);
                this.processing = false;
            }).finally(() => {
                this.props.hideModal();
            });
            return;
        }

        console.log("Card Number parameter is");
        console.log(card_number);
        let card = card_number != "" ? card_number : this.state.card_input;
        
        let badge = ""
        if(this.isPCRSpecialCase()) badge = card;

        this.props.showModal("Registering new player...")
        this.toggleDupeEmailModal(false);
        this.toggleRegisterModal(false);

        FirebaseService.logEvent("register_card", {"venue_id": this.state.venue.id, "card_num": card, "email": email});
        GameService.postNewPlayer(card, email, firstname, lastname, badge).then((data) => {
            if(data.card_number == null) data.card_number = card
            this.markRegisteredThisSession();
            this.setState({
                card_input: "",
                register_modal: false,
                register_input: {email: "", firstname: "", lastname: "", valid: false},
                player: data
            }, () => {
                // SUR-401 -- a live Survivor promotion takes over the lobby.
                // Its entry manager lists every active promotion (SUR-402), so
                // there is nothing the lobby would still be needed for.
                if(this.toPrePickIfSurvivor()) return;
                if(this.state.promos.length == 1){
                    this.playGame(this.state.promos[0]);
                }else{
                    this.setState({
                        welcome_modal: true
                    })
                }
            });
        }).catch(error => {
            console.log(error);
            this.processing = false;
        }).finally(() => {
            if (!this.isRemote()) this.startTwentyMinTimeout();
            this.props.hideModal();
        });
    }

    updatePlayer(e){
        if(e) e.preventDefault();

        var curr_player = JSON.parse(JSON.stringify(this.state.player))
        let firstname = this.state.register_input.firstname;
        let lastname = this.state.register_input.lastname;
        let email = this.state.register_input.email;
        let playerid = curr_player.id;

        this.props.showModal("Updating player info...")
        this.toggleUpdateModal(false);

        GameService.postUpdatePlayer(playerid, firstname, lastname, email).then((data) => {
            curr_player.first_name = firstname;
            curr_player.last_name = lastname;
            curr_player.email = email;
            this.markRegisteredThisSession();
            this.setState({
                card_input: "",
                register_modal: false,
                register_input: {email: "", firstname: "", lastname: "", valid: false},
                player: curr_player
            }, () => {
                // SUR-401 -- a live Survivor promotion takes over the lobby.
                // Its entry manager lists every active promotion (SUR-402), so
                // there is nothing the lobby would still be needed for.
                if(this.toPrePickIfSurvivor()) return;
                if(this.state.promos.length == 1){
                    this.playGame(this.state.promos[0]);
                }else{
                    this.setState({
                        welcome_modal: true
                    })
                }
            });
        }).catch(error => {
            console.log(error);
            this.processing = false;
        }).finally(() => {
            if (!this.isRemote()) this.startTwentyMinTimeout();
            this.props.hideModal();
        });
    }

    addCardToPlayer(e){
        if(e) e.preventDefault();

        var new_player = JSON.parse(JSON.stringify(this.state.player))
        let card = this.state.card_input;
        let playerid = new_player.id;

        this.props.showModal("Registering new player...")
        this.toggleDupeEmailModal(false);
        this.toggleRegisterModal(false);

        FirebaseService.logEvent("register_card", {"venue_id": this.state.venue.id, "card_num": card, "email": new_player.email});
        GameService.postAddPlayerCard(playerid, card).then((data) => {
            new_player.card_number = card
            this.setState({
                card_input: "",
                register_modal: false,
                register_input: {email: "", firstname: "", lastname: "", valid: false},
                player: new_player
            }, () => {
                // SUR-401 -- a live Survivor promotion takes over the lobby.
                // Its entry manager lists every active promotion (SUR-402), so
                // there is nothing the lobby would still be needed for.
                if(this.toPrePickIfSurvivor()) return;
                if(this.state.promos.length == 1){
                    this.playGame(this.state.promos[0]);
                }else{
                    this.setState({
                        welcome_modal: true
                    })
                }
            });
        }).catch(error => {
            console.log(error);
            if(error.response.status == 409){
                this.tooglePlayerErrorModal(true, "Something went wrong!", "We couldn't complete your request.\nPlease ask for assistance.");
            }
            this.processing = false;
        }).finally(() => {
            this.startTwentyMinTimeout();
            this.props.hideModal();
        });
    }

    playGame(item){
        this.setState({
            welcome_modal: false
        }, () => {
            this.props.showModal("Loading game...")

            let cardnumber = this.state.player.card_number || ""
            let playerid = this.state.player.id;
            let promoid = item.promo.id;
            let time = moment().format();

            FirebaseService.logEvent("navigate_to_promo", {"venue_id": this.state.venue.id, "card_num": cardnumber, "promo_id": promoid})
            GameService.playGame(cardnumber, promoid, time, playerid).then((data) => {
                if(data.can_play_promo == true){
                    let url = "";
                    switch(item.promo.game_type){
                        case 0:
                            url = "head_to_head";
                            break;
                        case 1:
                            url = "placement";
                            break;
                        case 2:
                            url = "bracket";
                            break;
                        case 3:
                            url = "pick_the_props";
                            break;
                        case 4:
                            url = "survivor";
                            break;
                        default:
                    }
                    // Survivor's state response is the whole ticket-selector
                    // screen — entries, grid, and the copy for every state.
                    // Handing it over avoids the selector re-fetching what the
                    // lobby has already asked for one call earlier.
                    this.redirectToGame(url, item, item.promo.game_type === 4 ? data : null);
                }else{
                    // Ending the remote session here is only right when this was
                    // the player's only option. With several promotions live they
                    // may have just re-tapped one they already played today, so
                    // dismissing the modal drops them back in the lobby instead.
                    if (this.isRemote() && this.state.promos.length <= 1) {
                        this.pendingRemoteResult = "denied_daily_limit";
                    }
                    // Survivor has its own reason for turning a player away —
                    // usually "you have no surviving tickets", which is not a
                    // come-back-tomorrow situation at all. The server resolves
                    // the wording so the admin's consolation message and the
                    // fallback copy stay in one place.
                    if(item.promo.game_type === 4 && data.headline){
                        this.tooglePlayerErrorModal(true, "Survivor Pool", data.headline, item.promo.league && item.promo.league.error_image);
                    }else{
                        this.tooglePlayerErrorModal(true, "Please come back tomorrow", "You may only play once per day.\nPlease play again tomorrow.", item.promo.league && item.promo.league.error_image);
                    }
                }
            }).catch(error => {
                console.log(error)
                this.processing = false;
            }).finally(() => {
                this.startTwentyMinTimeout();
                this.props.hideModal();
            });;
        })
    }

    /**
     * SUR-402 — launch the promotion the entry manager was asked to play.
     *
     * Returns true when it has taken over. The player is already identified —
     * they came from a screen that only exists after identification — so this
     * goes straight to playGame, which is the same call the lobby tiles make.
     *
     * Guarded on the promo still being live: the entry manager's payload is a
     * render of a moment, and the window can close between reading it and
     * tapping. Falling through to the lobby is the right failure, not a crash.
     */
    consumeAutoPlay(){
        let nav = this.props.router.location.state;
        if(!nav || !nav.auto_play_promo_id) return false;

        let item = (this.state.promos || []).find(
            p => p.promo && p.promo.id === nav.auto_play_promo_id
        );
        if(!item) return false;

        // Consumed once. Without clearing it, every later re-render of the lobby
        // would relaunch the same promotion.
        this.props.router.navigate(this.props.router.location.pathname, {
            replace: true,
            state: {venue: nav.venue, player: nav.player}
        });

        this.setState({player: nav.player}, () => this.playGame(item));
        return true;
    }

    /**
     * SUR-401 — send an identified player to the Survivor entry manager.
     *
     * Returns true when it has taken over, so each identification path can bail
     * out of its own single-promo auto-dispatch. There are eight of those paths
     * (new player, returning card, PIN, club registration, profile update…) and
     * they all end the same way, so the branch goes in front of each rather than
     * being threaded through a ninth variation of the same code.
     *
     * `promos` is already filtered to promotions inside their date window with
     * status active — the same rule the server applies in
     * `survivor.active_promos_for_venue`, which is what the entry manager will
     * ask for a moment later.
     *
     * Deliberately unconditional on ticket state: whether the player holds
     * tickets, has played today, or is out of the pool entirely is the entry
     * manager's business to display, not the lobby's business to pre-judge.
     */
    toPrePickIfSurvivor(){
        let promos = this.state.promos || [];
        let survivor = promos.some(item => item.promo && item.promo.game_type === 4);
        if(!survivor) return false;

        // The entry manager is a screen about *this player's* tickets and has no
        // meaning without one. Not every one of the eight paths has committed the
        // player to state by the time it reaches its auto-dispatch, so rather
        // than audit each, refuse to take over and let the lobby handle it.
        if(!this.state.player || !this.state.player.id) return false;

        this.setState({
            redirect: {
                path: "/survivor/prepick",
                state: {
                    venue: this.state.venue,
                    player: this.state.player
                }
            }
        });
        return true;
    }

    redirectToGame(path, promos, survivor_state = null){
        let venue = this.state.venue;
        let promo = promos.promo;
        this.setState({
            redirect: {
                path: "/" + path,
                state: {
                    venue: venue,
                    promo: promo,
                    player: this.state.player,
                    // Survivor only; null for every other game type, which
                    // ignores it.
                    survivor_state: survivor_state
                }
            }
        });
    }

    onClickItem(index, item){
        //console.log(index);
        //console.log(item);
    }

    togglePinModal(new_state){
        this.setState({
            pin_modal: new_state
        })
    }

    // Registration modals aren't bound to a single promo, so derive a warning
    // override from the first available league that defines one. Falls back to
    // the bundled football default when none is set.
    warningOverrideImage(){
        var promos = this.state.promos || [];
        for (var i = 0; i < promos.length; i++) {
            var lg = promos[i].promo && promos[i].promo.league;
            if (lg && lg.warning_image) return lg.warning_image;
        }
        return null;
    }

    /** Dismiss without the exit. A retry is not the end of the visit. */
    retryFromPlayerError(){
        var retry = this.state.player_error_modal.retry;
        this.pendingRemoteResult = null;
        this.processing = false;
        this.setState({
            player_error_modal: {show: false, title: "", body: "", image: null, retry: null}
        }, () => { if (typeof retry === "function") retry(); });
    }

    tooglePlayerErrorModal(new_state, new_title, new_body, new_image = null, retry = null){
        this.setState({
            player_error_modal: {show: new_state, title: new_title, body: new_body, image: new_image, retry: retry}
        }, () => {
            if(this.state.player_error_modal.show == false) {
                this.processing = false;
                if (this.isRemote()) {
                    var result = this.pendingRemoteResult || "error";
                    this.pendingRemoteResult = null;
                    exitGame({
                        remoteCtx: this.remoteCtx(),
                        setRedirect: (r) => this.setState({redirect: r}),
                        result: result,
                        player: playerEcho(this.state.player),
                    });
                }
            }
        })
    }

    togglePCRModal(new_state){
        this.setState({
            pcr_welcome_modal: new_state
        }, () => {
            if(this.state.pcr_welcome_modal == true){
                this.clearAllInput();
                this.startRegisterModalTimeout();

                let dom = document.querySelector('.pcr-special-modal input[id="badge"]');
                if(dom) dom.click();
                setTimeout(() => {
                    if(dom) dom.click();
                },100)
            }else{
                if(this.register_timeout_function) clearTimeout(this.register_timeout_function);
                this.processing = false;
            }
        })
    }

    toggleRegisterModal(new_state){
        this.setState({
            register_modal: new_state
        }, () => {
            if(this.state.register_modal == true){
                this.startRegisterModalTimeout();

                let dom = document.querySelector('.registration-modal input[id="firstname"]');
                if(dom) dom.click();
                setTimeout(() => {
                    if(dom) dom.click();
                },100)
            }else{
                if(this.register_timeout_function) clearTimeout(this.register_timeout_function);
                this.processing = false;
            }
        })
    }

    toggleUpdateModal(new_state){
        this.setState({
            update_modal: new_state
        }, () => {
            if(this.state.update_modal == true){
                this.startRegisterModalTimeout()

                var dom = null
                if(this.state.register_input.firstname == "") dom = document.querySelector('.update-modal input[id="firstname"]');
                else if(this.state.register_input.lastname == "") dom = document.querySelector('.update-modal input[id="lastname"]');
                else if(this.state.register_input.email == "") dom = document.querySelector('.update-modal input[id="email"]');
                if(dom) dom.click();
                setTimeout(() => {
                    if(dom) dom.click();
                },100)
            }else{
                if(this.register_timeout_function) clearTimeout(this.register_timeout_function);
                this.processing = false;
            }
        })
    }

    toggleDupeEmailModal(new_state){
        this.setState({
            dupe_email_modal: new_state
        }, () => {
            if(this.state.dupe_email_modal == true){
                this.startRegisterModalTimeout()
            }else{
                if(this.register_timeout_function) clearTimeout(this.register_timeout_function);
                this.processing = false;
            }
        })
    }

    startRegisterModalTimeout(){
        // Walk-away protection for an unattended kiosk: clear a half-typed
        // registration so the next person doesn't inherit it. On the web there
        // is no next person, the device belongs to the player, and 60 seconds
        // is an easy amount of time to spend typing an email on a phone —
        // wiping their form would be a bug, not a safeguard.
        if (this.isWebMode()) return;

        if(this.register_timeout_function) clearTimeout(this.register_timeout_function);
        this.register_timeout_function = setTimeout(() => {
            this.setState({
                card_input: '',
                register_input: {email: "", firstname: "", lastname: "", valid: false}
            }, () => {
                let dom = document.getElementsByTagName("BODY")[0];
                if(dom) dom.click();
                this.toggleRegisterModal(false)
                this.togglePCRModal(false)
            });
        }, 60000);
    }

    toggleWelcomeModal(new_state){
        this.setState({
            welcome_modal: new_state
        }, () => {
            if(this.state.welcome_modal == false) this.processing = false;
        })
    }

    focusInput(name){
        this.setState({
            input_name: name,
        })
    }

    onKeyboardInputChange = (input) => {
        this.applyInputValue(this.state.input_name, input);
    }

    // Single source of truth for applying a value to a named field, whether it
    // came from the on-screen keyboard or a physical keyboard.
    applyInputValue = (name, value) => {
        switch(name){
            case "email": {
                var curr_input = JSON.parse(JSON.stringify(this.state.register_input));
                curr_input.email = value;
                this.setState({
                    register_input: curr_input
                }, () => {
                    this.checkInputValue();
                    this.startRegisterModalTimeout();
                });
                break;
            }
            case "firstname": {
                var curr_input = JSON.parse(JSON.stringify(this.state.register_input));
                curr_input.firstname = value;
                this.setState({
                    register_input: curr_input
                }, () => {
                    this.checkInputValue();
                    this.startRegisterModalTimeout();
                });
                break;
            }
            case "lastname": {
                var curr_input = JSON.parse(JSON.stringify(this.state.register_input));
                curr_input.lastname = value;
                this.setState({
                    register_input: curr_input
                }, () => {
                    this.checkInputValue();
                    this.startRegisterModalTimeout();
                });
                break;
            }
            case "badge":
                this.setState({
                    card_input: value
                }, () => {
                    this.startRegisterModalTimeout();
                });
                break;
        }
    }

    // True when this is a remote launch that asked for the on-screen keyboard to
    // be OFF. In that mode the fields must accept the physical/computer keyboard
    // (otherwise — fields being readOnly and the soft keyboard hidden — there is
    // no way to type at all).
    physicalKeyboardMode(){
        var remote = readRemoteSession();
        return !!(remote && remote.isRemote
                  && remote.displayOptions
                  && remote.displayOptions.keyboard === "off");
    }

    // Physical-keyboard input path. Mirror the value into the soft keyboard's
    // buffer too, so state stays consistent if the mode ever toggles.
    handleTyping = (name, value) => {
        if (this.keyboard && this.keyboard.current) {
            try { this.keyboard.current.setInput(value, name); } catch(e) { /* ignore */ }
        }
        this.applyInputValue(name, value);
    }

    clearAllInput = () => {
        this.keyboard.current.clearInput("email");
        this.keyboard.current.clearInput("firstname");
        this.keyboard.current.clearInput("lastname");
        this.keyboard.current.clearInput("badge");
    }

    /**
     * What is wrong with the registration details, in words a player can act
     * on — or "" when there is nothing wrong.
     *
     * Returned as a sentence rather than a boolean because a player who is
     * being kept out has to be told which field, and why. The single source of
     * truth for both: the button reads this, and so does the message beside it.
     */
    registrationProblem = () => {
        let input = this.state.register_input;
        let firstname = (input.firstname || "").trim();
        let lastname = (input.lastname || "").trim();
        let email = (input.email || "").trim();

        if (!firstname) return "Please enter your first name.";
        if (!lastname) return "Please enter your last name.";
        if (!email) return "Please enter your email address.";

        /*
         * Deliberately permissive: one @, something either side of it, and a
         * dot in the domain with at least two characters after the last one.
         *
         * The rule it replaces capped the last part at three characters, so it
         * turned away .info, .tech, .store, .email, .online — and every new
         * extension after them. New ones appear constantly, and there is no
         * list worth keeping up to date. Locking a player out of a promotion
         * because we have not heard of their domain is a far worse failure
         * than accepting an address that turns out not to exist; the email
         * itself is what proves that, not a regex here.
         */
        let email_pattern = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;
        if (!email_pattern.test(email)) {
            return "That email address doesn't look right. Please check it for a typo.";
        }
        return "";
    }

    checkInputValue = () => {
        var curr_input = JSON.parse(JSON.stringify(this.state.register_input));
        curr_input.valid = this.registrationProblem() === "";
        this.setState({
            register_input: curr_input,
            // Clears as they fix it. A message about a field they have already
            // corrected is worse than no message.
            register_error: "",
        });
    }

    /**
     * Continue, from any of the registration screens.
     *
     * The button is live even when the details are wrong, and says why when
     * pressed. A disabled button with no explanation is the failure this
     * replaces: the details were prefilled and looked fine, the button did
     * nothing, and the screen offered no reason at all.
     */
    submitIfComplete = (submit) => {
        let problem = this.registrationProblem();
        if (problem) {
            this.setState({ register_error: problem });
            return;
        }
        this.setState({ register_error: "" }, submit);
    }

    onClickCarousel(){
        if(this.state.click == true) return;
        this.setState({
            click: true
        });
    }

    slideOnClickHandler = () => {
        if(this.isPCRSpecialCase() == false) return

        this.setState({
            card_input: "",
            register_input: {email: "", firstname: "", lastname: "", valid: false},
        }, () => {
            this.togglePCRModal(true);
        })
    }

    renderCalendarPage(){
        const newPage = document.createElement('div');
        newPage.classList.add('page');
        newPage.innerHTML = `
            <p class="month">${this.monthName}</p>
            <p class="day">${this.dayNum}</p>
            <p class="day-name">${this.dayName}</p>
        `;

        const pages = document.querySelector('.pages');
        pages.appendChild(newPage);

        setTimeout(() => {
            this.updateCalendarPage();
        }, 1600)
    }

    updateCalendarPage(){
        if (this.dayNum < this.daysInMonth(this.month, this.year)) {
            this.dayNum++;
        } else {
            this.dayNum = 1;
        }

        if (this.dayNum === 1 && this.month < 11) {
            this.month++;
        } else if (this.dayNum === 1 && this.month === 11) {
            this.month = 0;
        }

        if (this.dayNum ===1 && this.month === 0) {
            this.year++;
        }
        const newDate = new Date(this.year, this.month, this.dayNum);
        this.dayName = newDate.toLocaleString('en-us', { weekday: 'long' });
        this.monthName = newDate.toLocaleString('en-us', { month: 'long' });

        const page = document.querySelector('.page');
        const pages = document.querySelector('.pages');
        page.classList.add('tear');
        setTimeout(() => {
            pages.removeChild(page);
        }, 800);

        this.renderCalendarPage();
    }

    daysInMonth (month, year) {
        return new Date(year, month + 1, 0).getDate();
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect.path} state={this.state.redirect.state} />
        }

        return (
            <div id="home">
                {(this.state.page_ready) ?
                <div>
                    <Modal className="player-error-modal" show={this.state.player_error_modal.show} animation={true} centered>
                        <Modal.Header>
                            <Modal.Title className="w-100 text-center">
                                <div><FaFlag style={{ color: "#dc3545" }} /> {this.state.player_error_modal.title}</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="pb-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col text-center">
                                        <img src={this.state.player_error_modal.image || "/assets/images/refree2.png"} width={"200px"}/>
                                    </div>
                                    <div className="col text-start d-flex align-items-center">
                                        <div>{this.state.player_error_modal.body}</div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="container m-0 p-0">
                                <div className="row">
                                    {this.state.player_error_modal.retry ? (
                                        <div className="col d-grid"><Button variant="outline-secondary" onClick={e => this.retryFromPlayerError()}>Try again</Button></div>
                                    ) : null}
                                    <div className="col d-grid"><Button variant="primary" onClick={e => this.tooglePlayerErrorModal(false, "", "")}>Continue</Button></div>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Numpad title="Enter PIN" body="Enter your existing Player’s Club PIN" size="md" show_numpad={this.state.pin_modal} onSubmitInput={(new_input) => this.submitPin(new_input)} type="password"/>
                    <Modal className="welcome-modal" show={this.state.welcome_modal} onHide={() => {this.toggleWelcomeModal(false)}} animation={true} centered>
                        <Modal.Header>
                            <Modal.Title className="w-100">
                                <div className="container">
                                    <div className="row">
                                        <div className="col text-center">{this.state.venue.lobby_message}</div>
                                    </div>
                                </div>
                            </Modal.Title>
                        </Modal.Header>
                        {this.state.player && this.state.player.points_earned && this.state.player.earned_entries && this.state.player.times_played_this_week && this.state.player.points_needed &&
                            <Modal.Body>
                                <div className="container text-center">
                                    <div className="row">
                                        <div className="col">You earned {this.state.player && this.state.player.points_earned} {this.state.venue.name}'s Points</div>
                                    </div>
                                    <div className="row">
                                        <div className="col fs-2 fw-bold">You can play {this.state.player && (this.state.player.earned_entries - this.state.player.times_played_this_week)} {this.state.player && (this.state.player.earned_entries - this.state.player.times_played_this_week) > 1 ? "times" : "time"}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col">For games starting on or after {this.state.eariliest_date && moment(this.state.eariliest_date).format("MMM DD")}</div>
                                    </div>
                                    <div className="row mt-4">
                                        <div className="col fs-5">Earn {this.state.player && this.state.player.points_needed} points for next free play</div>
                                    </div>
                                    <div className="row">
                                        <div className="col">Play up to 6 tickets each week</div>
                                    </div>
                                </div>
                            </Modal.Body>
                        }
                        <Modal.Footer style={{justifyContent: "center"}}>
                            <div className="fs-5 fw-bold">Tap to Play</div>
                            <div className="carousel-container-popup">
                                {(this.state.promos.length > 0) ?

                                <div className="row d-flex align-items-center justify-content-center">
                                    {this.state.promos.map((item, index) => (
                                        <div key={index} onClick={e => this.playGame(item)} className="text-center" style={{width: "33%"}}>
                                            <img src={item.promo.icon_image_url} style={{width: "90%"}} />
                                        </div>
                                    ))}
                                </div>: null
                                }
                            </div>

                        </Modal.Footer>
                    </Modal>
                    {/*
                      Standalone web promotion: the club-number gate. A plain
                      input with inputMode="numeric" rather than the Numpad
                      component — a phone raises its own numeric keypad on
                      focus, and on a desktop a numpad would mean mouse-clicking
                      every digit. See docs/standalone-web-promotion-plan.md §7.
                    */}
                    <Modal className="club-modal" show={this.state.club_modal} animation={true} backdrop="static" centered>
                        <Modal.Header>
                            <Modal.Title className="w-100 text-center">
                                {this.state.venue.lobby_message || "Welcome"}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={(e) => { e.preventDefault(); this.submitClubNumber(); }}>
                                <Form.Group className="mb-2">
                                    <Form.Label>Players Club Number</Form.Label>
                                    {/*
                                      autoComplete is deliberately ON and the
                                      input is named. The cookie is the primary
                                      way a player avoids retyping this, but
                                      when it is missing — cleared, expired, a
                                      different browser — the browser's own
                                      typeahead is the fallback, and "off"
                                      would suppress exactly that.
                                    */}
                                    <Form.Control
                                        id="clubnumber"
                                        name="clubnumber"
                                        type="text"
                                        inputMode="numeric"
                                        autoComplete="on"
                                        autoFocus
                                        placeholder="Enter your Players Club number"
                                        value={this.state.club_input}
                                        onChange={e => this.setState({ club_input: e.target.value })}
                                    />
                                </Form.Group>
                                <div className="text-muted" style={{ fontSize: "0.9em" }}>
                                    We'll remember you on this device, so you only have to do this once.
                                </div>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="container m-0 p-0">
                                <div className="row">
                                    <div className="col d-grid">
                                        <Button variant="primary"
                                            disabled={!(this.state.club_input || "").trim()}
                                            onClick={() => this.submitClubNumber()}
                                        >
                                            Continue
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    {/*
                      Confirmation screen. Shown on every first visit even when
                      the profile we found is complete — a stale email is the
                      commonest real problem and this is the only place to fix
                      it. The club number is read-only: it is how they were
                      identified, not something to edit here.
                    */}
                    <Modal className="web-confirm-modal update-modal" show={this.state.web_confirm_modal} animation={true} backdrop="static" centered>
                        <Modal.Header>
                            <Modal.Title className="w-100 text-center">
                                {this.state.player ? "Is this still right?" : "Tell us who you are"}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className="mb-3">
                                <Form.Label>Players Club Number</Form.Label>
                                <Form.Control id="clublocked" type="text" value={this.state.club_locked} readOnly disabled />
                            </Form.Group>
                            <div className="row">
                                <div className="col">
                                    <Form.Group className="mb-3">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control id="firstname" type="text" placeholder="Enter First Name" value={this.state.register_input.firstname} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("firstname")} onChange={e => this.handleTyping("firstname", e.target.value)} />
                                    </Form.Group>
                                </div>
                                <div className="col">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Last</Form.Label>
                                        <Form.Control id="lastname" type="text" placeholder="Enter Last Name" value={this.state.register_input.lastname} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("lastname")} onChange={e => this.handleTyping("lastname", e.target.value)} />
                                    </Form.Group>
                                </div>
                            </div>
                            <Form.Group className="mb-3">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control id="email" type="email" placeholder="Enter email" value={this.state.register_input.email} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("email")} onChange={e => this.handleTyping("email", e.target.value)} />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="container m-0 p-0">
                                {/*
                                  Directly above the button that was pressed —
                                  the one place the player is certainly looking.
                                */}
                                {this.state.register_error &&
                                    <div className="row">
                                        <div className="col">
                                            <div className="alert alert-danger py-2 mb-3" role="alert">
                                                {this.state.register_error}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col d-grid">
                                        <Button variant="secondary"
                                            onClick={() => this.setState({
                                                web_confirm_modal: false,
                                                club_input: "",
                                                club_locked: "",
                                                player: null,
                                                register_input: {email: "", firstname: "", lastname: "", valid: false},
                                                register_error: "",
                                                club_modal: true,
                                            })}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                    <div className="col d-grid">
                                        <Button variant="primary"
                                            onClick={() => this.submitIfComplete(() => this.submitWebRegistration())}
                                        >
                                            Continue
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal className="update-modal" show={this.state.update_modal} animation={true} backdrop="static" centered>
                        <Modal.Header>
                            <Modal.Title>
                            <   div className="container">
                                    <div className="row">
                                        <div className="col-auto text-center">
                                            <img src="/assets/images/rename.png" width={"100px"}/>
                                        </div>
                                        <div className="col text-start d-flex align-items-center">
                                            Please add your name to help us reach our winners
                                        </div>
                                    </div>
                                </div>

                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col">
                                    <Form.Group className="mb-3">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control id="firstname" type="text" placeholder="Enter First Name" value={this.state.register_input.firstname} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("firstname")} onChange={e => this.handleTyping("firstname", e.target.value)} />
                                    </Form.Group>
                                </div>
                                <div className="col">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Last</Form.Label>
                                        <Form.Control id="lastname" type="text" placeholder="Enter Last Name" value={this.state.register_input.lastname} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("lastname")} onChange={e => this.handleTyping("lastname", e.target.value)} />
                                    </Form.Group>
                                </div>
                            </div>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control id="email" type="email" placeholder="Enter email" value={this.state.register_input.email} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("email")} onChange={e => this.handleTyping("email", e.target.value)} />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="container m-0 p-0">
                                {this.state.register_error &&
                                    <div className="row">
                                        <div className="col">
                                            <div className="alert alert-danger py-2 mb-3" role="alert">
                                                {this.state.register_error}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col d-grid">
                                        <Button variant="secondary"
                                            onClick={(e) => {
                                                this.toggleUpdateModal(false)
                                                // SUR-401 -- a live Survivor promotion takes over the lobby.
                                                // Its entry manager lists every active promotion (SUR-402), so
                                                // there is nothing the lobby would still be needed for.
                                                if(this.toPrePickIfSurvivor()) return;
                                                if(this.state.promos.length == 1){
                                                    this.playGame(this.state.promos[0]);
                                                }else{
                                                    this.setState({
                                                        welcome_modal: true
                                                    })
                                                }
                                            }}
                                        >
                                            Skip
                                        </Button>
                                    </div>
                                    <div className="col d-grid"><Button variant="primary"
                                        onClick={(e) => this.submitIfComplete(() => this.updatePlayer(e))}
                                    >
                                        Update
                                    </Button></div>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal className="pcr-special-modal" show={this.state.pcr_welcome_modal} animation={true} backdrop="static" centered>
                        <Modal.Header>
                            <Modal.Title>Welcome {this.state.venue.name}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Badge Number</Form.Label>
                                    <Form.Control id="badge" type="text" placeholder="Enter Badge Number" value={this.state.card_input} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("badge")} onChange={e => this.handleTyping("badge", e.target.value)} />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="container m-0 p-0">
                                <div className="row">
                                    <div className="col d-grid">
                                        <Button variant="secondary"
                                            onClick={(e) => {
                                                FirebaseService.logEvent("pcr_welcome_cancel", {"venue_id": this.state.venue.id, "card_num": this.state.card_input})
                                                this.setState({card_input: '', register_input: {email: "", firstname: "", lastname: "", valid: false}}); this.togglePCRModal(false)}
                                            }
                                        >
                                            Close
                                        </Button>
                                    </div>
                                    <div className="col d-grid"><Button variant="primary" disabled={this.state.card_input == "" ? true : false}
                                        onClick={(e) => {
                                            var card_num = this.state.card_input
                                            this.setState({ read_card_ready: false, modal: {show: false, text: ""}, card_input: "" }, () => {
                                                this.togglePCRModal(false);
                                                this.getPlayerInfo(card_num);
                                            });
                                        }}
                                    >
                                        Confirm
                                    </Button></div>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal className="registration-modal" show={this.state.register_modal} animation={true} backdrop="static" centered>
                        <Modal.Header>
                            <Modal.Title>Registration</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col">
                                    <Form.Group className="mb-3">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control id="firstname" type="text" placeholder="Enter First Name" value={this.state.register_input.firstname} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("firstname")} onChange={e => this.handleTyping("firstname", e.target.value)} />
                                    </Form.Group>
                                </div>
                                <div className="col">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Last</Form.Label>
                                        <Form.Control id="lastname" type="text" placeholder="Enter Last Name" value={this.state.register_input.lastname} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("lastname")} onChange={e => this.handleTyping("lastname", e.target.value)} />
                                    </Form.Group>
                                </div>
                            </div>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control id="email" type="email" placeholder="Enter email" value={this.state.register_input.email} readOnly={!this.physicalKeyboardMode()} onClick={e => this.focusInput("email")} onChange={e => this.handleTyping("email", e.target.value)} />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="container m-0 p-0">
                                {this.state.register_error &&
                                    <div className="row">
                                        <div className="col">
                                            <div className="alert alert-danger py-2 mb-3" role="alert">
                                                {this.state.register_error}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row">
                                    <div className="col d-grid">
                                        <Button variant="secondary"
                                            onClick={(e) => {
                                                FirebaseService.logEvent("register_card_cancel", {"venue_id": this.state.venue.id, "card_num": this.state.card_input})
                                                this.setState({card_input: '', register_error: "", register_input: {email: "", firstname: "", lastname: "", valid: false}}); this.toggleRegisterModal(false)}
                                            }
                                        >
                                            Close
                                        </Button>
                                    </div>
                                    <div className="col d-grid"><Button variant="primary"
                                        onClick={(e) => this.submitIfComplete(() => this.checkExistingPlayer(e))}
                                    >
                                        Register
                                    </Button></div>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal className="home-modal" show={this.state.modal.show} animation={true} centered>
                        <Modal.Body className='text-center' style={{"fontSize": "1.2em"}}>
                            <div className="swipe-card-container">
                                <FaIdCard className="card-swipe mb-2" style={{ fontSize: "3em" }}/>
                                <div className="card-swipe-bar-front"></div>
                                <div className="card-swipe-bar-back"></div>
                                <div className="card-swipe-bar-back-2"></div>
                            </div>
                            <br />
                            {this.state.modal.text}
                        </Modal.Body>
                    </Modal>
                    <Modal className="dupe-email-modal" show={this.state.dupe_email_modal} animation={true} backdrop="static" centered>
                        <Modal.Header>
                            <Modal.Title>Duplicate Email</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="container">
                                <div className="row">
                                    <div className="col text-center d-flex align-items-center">
                                        <img src={this.warningOverrideImage() || "/assets/images/refree-yellow-card-2.png"} width={"200px"}/>
                                    </div>
                                    <div className="col text-start d-flex align-items-center">
                                        <ul className="text" style={{paddingLeft: "0px"}}>
                                            <li style={{listStyle: "none"}}>
                                                This email has already registered for this promotion.<br /><br />If this was you, please tap <b>Continue</b> to add this card to your account.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="container m-0 p-0">
                                <div className="row">
                                    <div className="col d-grid">
                                        <Button variant="secondary"
                                            onClick={(e) => {
                                                FirebaseService.logEvent("register_card_cancel", {"venue_id": this.state.venue.id, "card_num": this.state.card_input})
                                                this.setState({card_input: '', register_input: {email: "", firstname: "", lastname: "", valid: false}}); this.toggleDupeEmailModal(false)}
                                            }
                                        >
                                            Close
                                        </Button>
                                    </div>
                                    <div className="col d-grid">
                                        <Button variant="primary" onClick={(e) => this.addCardToPlayer(e)}>Continue</Button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <div className="main-carousel carousel-container" style={{position: "fixed", top: "0", width: "100%"}}>
                        {(this.state.promos.length > 1) &&
                        <Carousel
                            infiniteLoop={this.state.promos.length > 3 ? true : false}
                            centerSlidePercentage={this.state.promos.length == 1 ? 100 : this.state.promos.length == 2 ? 50 : 33}
                            autoPlay={this.state.promos.length > 3 ? true : false} interval={4000}
                            showArrows={false} stopOnHover={false} showThumbs={false} showIndicators={false} centerMode={true} dynamicHeight={false}
                            renderArrowPrev={(onClickHandler, hasPrev, label) =>
                                this.state.promos.length > 3  && (
                                    <Button type="button" onClick={onClickHandler} title={label}
                                        style={{ ...arrowStyles, left: 0, padding: "0px 5px 0px 10px" }}
                                    >
                                        <FaCaretLeft style={{ fontSize: "3em" }} />
                                    </Button>
                                )
                            }

                            renderArrowNext={(onClickHandler, hasNext, label) =>
                                this.state.promos.length > 3  && (
                                    <div onClick={e => this.onClickCarousel()}>
                                        <Button type="button" onClick={onClickHandler} title={label}
                                            style={{ ...arrowStyles, right: 0, padding: "0px 10px 0px 5px" }}
                                        >
                                            <FaCaretRight style={{ fontSize: "3em" }} />
                                        </Button>
                                    </div>
                                )
                            }
                        >
                            {this.state.promos.map((item, index) => (
                                <div key={index} className="my-slide" onClick={e => this.slideOnClickHandler()}>
                                    {/*<Link to="/nfl" state={{ promo: item.promo }}>*/}
                                        <img src={item.promo.icon_image_url} />
                                    {/*</Link>*/}
                                </div>
                            ))}
                        </Carousel>
                        }
                        {(this.state.promos.length == 1) &&
                            <div className="home-gradient-border">
                                <div className="home-frame">
                                    {/*
                                    <div className="home-quadrado">
                                        <img src={this.state.promos[0].promo.icon_image_url} className="home-logo shadowfilter"/>
                                        <img src="./assets/images/graphic-banner-1.png"className="home-banner"/>
                                    </div>
                                    <div className="home-calendar">
                                        <div className="calendar">
                                            <div className="pages"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <img src="./assets/images/graphic-insert-card.png" width="50%" className="home-insert-card"/>
                                        <img src="./assets/images/graphic-arrow-1.png" width="12%" className="home-arrow"/>
                                    </div>
                                    */}
                                    <div className="home-background">
                                        {this.state.promos.map((item, index) => (
                                            <div key={index} className="my-slide" onClick={e => this.slideOnClickHandler()}>
                                                {/*<Link to="/nfl" state={{ promo: item.promo }}>*/}
                                                    <img src={item.promo.icon_image_url} />
                                                {/*</Link>*/}
                                            </div>
                                        ))}

                                        {this.state.vid != "" &&
                                            <video className="home-video" playsInline autoPlay muted loop
                                                src={this.state.vid} type="video/mp4"
                                            ></video>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <VirtualKeyboard
                        ref={r => (this.keyboard.current = r)}
                        inputName={this.state.input_name}
                        onChange={this.onKeyboardInputChange}
                    />
                    {this.state.vid != "" &&
                        <video className="home-video-2" playsInline autoPlay muted loop
                            src={this.state.vid} type="video/mp4"
                        ></video>
                    }
                </div>: null
                }
            </div>
        );
    }
}

export default withRouter(Home);